import { __read } from "tslib";
import HarmonySuspense from '@office-start/harmony-suspense';
import { IDLE_LOW_PRIORITY, IMMEDIATE_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import React, { useEffect } from 'react';
/**
 * LazyFeature uses Suspense to render children that have been initialized
 * with React.lazy
 * @param param0 options object containing disabled and children
 * @returns If 'disabled' return null, if enabled, render using Suspense wrapping lazily initialized children
 */
export var LazyFeature = function (_a) {
    var disabled = _a.disabled, children = _a.children, fallback = _a.fallback, suspendUntilReady = _a.suspendUntilReady, _b = _a.schedulePriority, schedulePriority = _b === void 0 ? IDLE_LOW_PRIORITY : _b;
    var _c = __read(React.useState(schedulePriority === IMMEDIATE_PRIORITY), 2), isReady = _c[0], setIsReady = _c[1];
    useEffect(function () {
        if (!isReady) {
            var scheduleHandle_1 = scheduleWork(function () {
                setIsReady(true);
            }, schedulePriority);
            return function () {
                scheduleHandle_1.cancel();
            };
        }
        // Needed for all codepaths must return a value lint rule
        return function () { return undefined; };
    }, [isReady, schedulePriority]);
    if (disabled) {
        return null;
    }
    return (React.createElement(HarmonySuspense, { canLoadChildren: isReady, fallback: fallback, suspendUntilReady: suspendUntilReady }, children));
};
//# sourceMappingURL=LazyFeature.js.map